module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img9.a1215745.jpg";